import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import LoyaltyTierPill from 'loyalty/components/LoyaltyTierPill'
import TextLink from 'LuxKit/TextLink'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import styled from 'styled-components'

const Span = styled.div`
  display: inline-grid;
  grid-template: 1ex / auto;
  place-items: center;
  vertical-align: middle;
  overflow: visible;
`

function TriplePointTakeoverHeroSubtitle() {
  const [tier] = useCurrentLoyaltyTier()
  const intl = useIntl()

  const triplePointsPill = (
    <Span>
      <LoyaltyTierPill kind="primary" tier={tier}>
        {intl.formatMessage({
          id: '3irLpPPES2',
          defaultMessage: 'Triple Points',
          description: 'Loyalty tier pill label for triple points promotion',
        })}
      </LoyaltyTierPill>
    </Span>
  )

  return <div>
    <FormattedMessage
      id="XNFcu303tz"
      defaultMessage="Look for {pill} on select packages! Hurry, limited time only. <link>View all offers</link>"
      description="Hero subtitle text directing users to look for triple points pill on select packages with link"
      values={{
        pill: triplePointsPill,
        link: (chunks) => <TextLink wrap="no-wrap" to="/triple-points">{chunks}</TextLink>,
      }}
    />
  </div>
}

export default TriplePointTakeoverHeroSubtitle
